import { useCallback } from 'react';
import clsx from 'clsx';
import { Box, Button } from '@alf/uikit';
import { Icon } from '@namespace/icons2';

import styles from './index.module.css';

export const ReceiptColumn = ({
  receiptUrl,
  receiptReturnUrl,
  iconOptions = {}
}) => {
  const onClick = useCallback(
    (url) => () => {
      window.open(url);
    },
    []
  );

  const { receiptIconColor = 'po_txt_color_1', wrapperClassName } = iconOptions;

  return (
    <Box
      className={clsx([
        styles.wrapper,
        wrapperClassName && styles[wrapperClassName]
      ])}
    >
      {receiptUrl && (
        <Button
          data-testid="receipt-btn"
          className={styles.button}
          intent="quaternary"
          iconOnly={true}
          onClick={onClick(receiptUrl)}
          iconLeft={
            <Icon
              name="icons/general/action/receipt"
              size="s"
              color={receiptIconColor}
            />
          }
        />
      )}

      {receiptReturnUrl && (
        <Button
          data-testid="receipt-return-btn"
          className={styles.button}
          intent="quaternary"
          iconOnly={true}
          onClick={onClick(receiptReturnUrl)}
          iconLeft={
            <Icon
              name="icons/general/action/receipt_return"
              size="s"
              color={receiptIconColor}
            />
          }
        />
      )}
    </Box>
  );
};
